import { AuthGrantTypeEnum } from './auth.constant';
import type { UserDataModel } from './auth.model';
import { api } from './auth.util';

async function getAccessTokenService(
  accessCode: string,
  clientAuthorizationToken: string,
  redirectUri: string,
  clientId: string
) {
  const authData = {
    grant_type: AuthGrantTypeEnum.AuthorizationCode,
    client_id: clientId,
    redirect_uri: redirectUri,
    code: accessCode
  };

  const response = await api(clientAuthorizationToken).post(
    '/oauth/token',
    authData
  );
  return response.data;
}

async function getUser(
  clientAuthorizationToken: string
): Promise<UserDataModel> {
  const response = await api(clientAuthorizationToken).get(
    '/v2/accounts/me?attributes=licensing_accounts'
  );

  return response.data;
}

export { getAccessTokenService, getUser };
